<template>
  <div>
    <div class="picker-row">
      <button
        class="w-8 h-8 flex justify-center items-center"
        :class="addColorStyle(0)"
        :style="{ background: store.color1 ? CSSRGB(store.color1) : 'white' }"
      >
        <plus-SVG v-if="!store.color1"/>
      </button>
      <div class="palette-row">
        <div v-for="(pRow, i) in colors" class="palette-chunk" :key="i">
          <div v-for="(color, j) in pRow" :key="j">
            <div
              class="color"
              :class="{'black-border':row==i&&id==j}"
              @click="
                currentPicker = 0;
                handlePick(i, j);
              "
              :style="[{ background: CSSRGB(color) },]"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="picker-row">
      <button class="w-8 h-8 flex justify-center items-center" 
      :class="addColorStyle(1)" :style="{background: store.color2 ? CSSRGB(store.color2) : 'transparent'}">
        <plus-SVG v-if="!store.color2" :class="{'stroke-gray-200':!store.color1}"/>
      </button>
      <div v-if="!store.color1" class="disabled-text">
        Add Complementary Color
      </div>
      <div class="palette-row">
        <div
          v-for="(color, i) in complementaryCols"
          :key="i"
          class="palette-chunk"
        >
          <div>
            <div class="color" :class="{'black-border':i==complementId}" @click="currentPicker=1;handlePick(i,j)" :style="{
            background: CSSRGB(color) }"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "../store";
import { colors, CSSRGB, getComplement, tint90, setTint } from "../js/palettes";
import PlusSVG from "./svg/PlusSVG.vue"

export default {
  name: "PalettePicker",
  components: {
    PlusSVG
  },
  data: () => ({
    store,
    colors,
    currentSelector: null,
    currentPicker: null,
    row: null,
    id: null,
    complementId: null,
    complementaryCols: null,
  }),
  methods: {
    buttonContent(pickerNumber) {
      let c;
      if (pickerNumber == 0) c = store.color1;
      if (pickerNumber == 1) c = store.color2;
      return c ? "" : "+";
    },
    CSSRGB,
    addColorStyle(i){
      switch(i){
        case 0: return{
          'static-black-btn': !store.color1,
          'color-btn': store.color1
        };
        case 1: return {
          'disabled-color-btn': !store.color1,
          'static-black-btn': store.color1 && !store.color2,
          'color-btn': store.color2
        };
        default: break;
      }
    },
    activateSelector(selector) {
      if (!store.color1 && selector == 1) {
        alert("to select a second color, please pick a first color");
      } else {
        this.currentSelector = selector;
      }
    },
    match2(row, id) {
      return row == this.row && id == this.id;
    },
    match1(id) {
      return id == this.complementId;
    },
    handlePick(i, j) {
      if (this.currentPicker == 0) {
        this.row = i;
        this.id = j;
        store.color1 = colors[i][j];
        store.color2 = null;
        this.complementId = null;
        this.complementaryCols = getComplement(i, j);
      } else if (this.currentPicker == 1) {
        store.color2 = this.complementaryCols[i];
        this.complementId = i;
        store.color3 = setTint(store.color2, 0.97);
      }
    },
    selectColor(row, id) {
      if (this.currentSelector == 0) {
        this.row = row;
        this.id = id;
        store.color1 = colors[row][id];
        store.color2 = null;
        this.complementId = null;
        this.complementaryCols = getComplement(row, id);
      } else if (this.currentSelector == 1) {
        store.color2 = this.complementaryCols[row];
        console.log(store.color2)
        this.complementId = row;
        store.color3 = tint90(store.color2);
      }
    },
  },
  computed: {
    noPrimaryBtn() {
      return {
        "disabled-btn": !store.color1,
      };
    },
  },
};
</script>
<style>

.picker-row {
  @apply flex items-center mb-4 mt-4;
}
.palette-chunk {
  @apply flex;
}
.disabled-text {
  @apply text-gray-300;
}
.palette-row {
  @apply flex;
}
.color {
  @apply block w-6 h-6 rounded-full mx-1 cursor-pointer ;
}

</style>